import React, {  useEffect, } from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import MainLayout from "../layouts/MainLayout";
import AuthLayout, { InvitationLayout } from "../layouts/AuthLayout";
import { ToastContainer } from "react-toastify";
import ExchangeIndex from "../Exchange/ExchangeIndex";
import {
  setTranslations,
  setDefaultLanguage,
  setLanguage,
} from "react-multi-lang";
import en from "../translations/en.json";
import es from "../translations/es.json";
import LoginIndex from "../Auth/LoginIndex";
import RegisterIndex from "../Auth/RegisterIndex";
import ProfileIndex from "../Profile/ProfileIndex";
import NewLandingIndex from "../LandingPage/LandingIndex";
import LandingLayout from "../layouts/LandingLayout";
import EmptyLayout from "../layouts/EmptyLayout";
import ScrollToTop from "../helper/ScrollToTop";
import ContactUsPageIndex from "../LandingPage/ContactUsPageIndex";
import OnboardingIndex from "../Onboarding/OnboardingIndex";
import PageNotFound from "../helper/PageNotFound";
import TermAndCondition from "../Static/NewStaticPage/TermAndCondition";
import AntiMoneyLaundering from "../Static/NewStaticPage/AntiMoneyLaundering";
import RiskDisclosurePolicy from "../Static/NewStaticPage/RiskDisclosurePolicy";
import UserAgreement from "../Static/NewStaticPage/UserAgreement";
import PrivacyAgreement from "../Static/NewStaticPage/PrivacyAgreement";
import Help from "../Static/NewStaticPage/Help";
import AboutUs from "../Static/NewStaticPage/AboutUs";
// import ContactUs from "../Static/NewStaticPage/ContactUs";
import StaticContactUs from "../Static/NewStaticPage/StaticContactUs";
import ThankYou from "../helper/ThankYou";
import { useSelector } from "react-redux";
import metaData from "../helper/metaData.json"
import TradeIndex from "../Trade/TradeIndex";
import BankAccountDetails from "../BankDetails/BankAccountDetails";
import AcceptInviteIndex from "../Auth/AcceptInviteIndex";
import NewLayout from "../layouts/NewLayout";
import KYCIndex from "../KYC/KYCIndex";

setTranslations({ en, es });

const $ = window.$;

const AppRoute = ({
  component: Component,
  layout: Layout,
  screenProps: ScreenProps,
  ...rest
}) => (
  <Layout screenProps={ScreenProps} {...rest}>
    <Component />
  </Layout>
);

const PrivateRoute = ({
  component: Component,
  layout: Layout,
  screenProps: ScreenProps,
  ...rest
}) => {
  let userId =
    localStorage.getItem("userId") || sessionStorage.getItem("userId");
  let accessToken =
    localStorage.getItem("token") || sessionStorage.getItem("token");
  let authentication = accessToken && userId ? true : false;
  return authentication === true ? (
    <Layout screenProps={ScreenProps}>
      <Component authRoute={true} />
    </Layout>
  ) : (
    <Navigate to={{ pathname: "/" }} />
  );
};

const App = () => {
  const location = useSelector((state) => state.user.location);

  useEffect(() => {
    const userLanguage = localStorage.getItem("lang")
      ? localStorage.getItem("lang")
      : "en";
    localStorage.setItem("lang", userLanguage);
    setDefaultLanguage(userLanguage);
  }, []);

  return (
    <>
      <ToastContainer />
      <Helmet>
        <title>{metaData[location == "/" ? "home" : location?.split("/")[1]]?.title}</title>
        <link
          rel="icon"
          type="image/png"
          href={window.location.origin + "/logo192.png"}
        />
      </Helmet>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* <Route
            path={"/widget"}
            element={
              <AppRoute component={WidgetComponent} layout={EmptyLayout} />
            }
          /> */}
          <Route
            path={"/"}
            element={
              // <AppRoute component={NewLandingIndex} layout={LandingLayout} />
             <AppRoute component={RegisterIndex} layout={MainLayout} />
            }
          />
          <Route
            path={"/kyc"}
            element={<AppRoute component={KYCIndex} layout={MainLayout} />}
          />

          <Route
            path={"/login"}
            element={<AppRoute component={LoginIndex} layout={MainLayout} />}
          /> 
          <Route
            path={"/register"}
            element={<AppRoute component={RegisterIndex} layout={MainLayout} />}
          />
          <Route
            path={"/terms-conditions"}
            element={
              <AppRoute component={TermAndCondition} layout={MainLayout} />
            }
          />
          <Route
            path={"/anti-money-laundering"}
            element={
              <AppRoute component={AntiMoneyLaundering} layout={MainLayout} />
            }
          />
          <Route
            path={"/risk-disclosure-policy"}
            element={
              <AppRoute component={RiskDisclosurePolicy} layout={MainLayout} />
            }
          />
          <Route
            path={"/user-agreement"}
            element={
              <AppRoute component={UserAgreement} layout={MainLayout} />
            }
          />
          <Route
            path={"/privacy-agreement"}
            element={
              <AppRoute component={PrivacyAgreement} layout={MainLayout} />
            }
          />
          <Route
            path={"/thank-you"}
            element={
              <AppRoute component={ThankYou} layout={MainLayout} />
            }
          />
          <Route
            path={"/help-center"}
            element={
              <AppRoute component={Help} layout={MainLayout} />
            }
          />
          <Route
            path={"/about-us"}
            element={
              <AppRoute component={AboutUs} layout={MainLayout} />
            }
          />
          <Route
            path={"/contact-us"}
            element={
              <AppRoute component={StaticContactUs} layout={MainLayout} />
            } />

          {/* Accept Invite Route */}
          <Route
            path={"/accept_invite"}
            element={<AppRoute component={AcceptInviteIndex} layout={InvitationLayout} />}
          />
          <Route
            path={"/profile"}
            element={
              <PrivateRoute component={ProfileIndex} layout={NewLayout} />
            }
          />
          <Route
            path={"/contact-us"}
            element={
              <AppRoute component={ContactUsPageIndex} layout={LandingLayout} />
            }
          />
          <Route
            path={"/onboarding"}
            element={
              <PrivateRoute component={OnboardingIndex} layout={AuthLayout} />
            }
          />
          <Route
            path={"/trading"}
            element={<AppRoute component={TradeIndex} layout={EmptyLayout} />}
          />
          {/* <Route
            path={"/onramp/:token"}
            element={<AppRoute component={SdkIndex} layout={EmptyLayout} />}
          /> */}
          <Route
            path={"/account-details"}
            element={<AppRoute component={BankAccountDetails} layout={NewLayout} />}
          />
          <Route
            path={"/*"}
            element={<AppRoute component={PageNotFound} layout={EmptyLayout} />}
          />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
